// FormSelect.js
import React from "react";
import { Select, SelectItem } from "@nextui-org/react";

const FormSelect = ({ label, placeholder, items, value, onSelectionChange, ...props }) => {
  // Mapping items to SelectItem components
  const options = items.map((item) => ({
    label: item,
    value: item,
  }));

  return (
    <div className="h-[80px] w-full">
      <Select
        isRequired
        label={label}
        radius="sm"
        variant="bordered"
        onSelectionChange={(val) => onSelectionChange(Array.from(val)[0])}
        classNames={{
          value: ["group-data-[has-value=true]:text-white"],
          selectorIcon: ["text-foreground-400"],
          trigger: ["border-default-400 data-[hover=true]:border-default-500"],
        }}
        {...props}
      >
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </Select>
    </div>
  );
};

export default FormSelect;
